import { useState } from 'react';
import { useRunReconciliation } from './hooks/useReconciliation';
import Button from '../../shared/components/Button';

interface Props {
  onClose: () => void;
}

export function RunReconciliationModal({ onClose }: Props) {
  const run = useRunReconciliation();
  const [provider, setProvider] = useState('PAYSTACK');
  const [period, setPeriod] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!period) { setError('Select a period to reconcile'); return; }
    await run.mutateAsync({ provider, period });
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 overflow-y-auto py-8">
      <div className="bg-card rounded-2xl shadow-xl w-full max-w-md mx-4 p-8">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-semibold text-foreground">Run Reconciliation</h2>
          <button onClick={onClose} className="text-muted-foreground hover:text-muted-foreground text-2xl leading-none">&times;</button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">Provider</label>
            <select
              className="w-full border border-border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-300"
              value={provider}
              onChange={(e) => setProvider(e.target.value)}
            >
              <option value="PAYSTACK">Paystack</option>
              <option value="FLUTTERWAVE">Flutterwave</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">Period (day) *</label>
            <input
              type="date"
              className="w-full border border-border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-300"
              value={period}
              onChange={(e) => setPeriod(e.target.value)}
            />
            <p className="text-xs text-muted-foreground mt-1">Re-runs the 3-way match for the selected provider and day.</p>
          </div>

          {error && <p className="text-sm text-red-500">{error}</p>}

          <div className="flex justify-end gap-3 pt-2">
            <button type="button" onClick={onClose} className="px-4 py-2 text-sm text-muted-foreground hover:text-foreground">
              Cancel
            </button>
            <Button type="submit" disabled={run.isPending}>
              {run.isPending ? 'Running…' : 'Run'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
